var map = {
	"./Courses/1.png": "t8DK",
	"./Courses/2.png": "VEBU",
	"./Courses/3.png": "174B",
	"./Courses/4.png": "2K4C",
	"./Courses/5.png": "lMa9",
	"./Courses/6.png": "MB3g",
	"./Courses/dotts.png": "JXUb",
	"./Courses/dotts.svg": "WBLQ",
	"./about-img.jpg": "QlZN",
	"./account-img.jpg": "eFlT",
	"./ach_locked.svg": "NV4U",
	"./achieve_img_1.svg": "HHLo",
	"./achieve_img_1_badge.svg": "ptIr",
	"./achieve_img_2.svg": "lUX9",
	"./achieve_img_2_badge.svg": "n+UP",
	"./achieve_img_3.svg": "Cz4o",
	"./achieve_img_3_badge.svg": "lqnD",
	"./achieve_img_4.svg": "aO+T",
	"./achieve_img_4_badge.svg": "f3PI",
	"./achieve_lock_img.png": "rQFW",
	"./achievements-icon.svg": "0ptq",
	"./achievments-icon.svg": "wzOn",
	"./active-step-dash.svg": "tI+P",
	"./address.svg": "fIwR",
	"./answer-img.svg": "HJVn",
	"./answer-img_1.svg": "6lBh",
	"./answer-img_2.svg": "xh7Y",
	"./answer-img_3.svg": "2SMT",
	"./apple-answer.svg": "P9I+",
	"./apple-question.svg": "6Sqz",
	"./apple.svg": "SwL9",
	"./arrow-contacts.svg": "h8VD",
	"./arrow-right.svg": "cXxo",
	"./articles-img.jpg": "zZJ5",
	"./artwork.svg": "nnYT",
	"./audio/5_how-do-we-stop-cavity-monsters.mp3": "OUYv",
	"./audio/5_uh-oh-cavity-monsters-coming.mp3": "TrNB",
	"./audio/5_yeah-your-fighting-the-cavity-monster.mp3": "4uFw",
	"./audio/7_good-for-me-or-good-for-cavity-monsters.mp3": "/SR3",
	"./audio/8_cavity-math_lets-see-how.mp3": "qB0v",
	"./audio/8_cavity-math_oh-no.mp3": "Utw9",
	"./audio/8_cavity-math_remember.mp3": "kE+J",
	"./audio/8_cavity-math_thats-right.mp3": "yYvX",
	"./audio/9_good-job.mp3": "nbN3",
	"./audio/9_unlocked-new-badge.mp3": "G4J5",
	"./audio/cavity-math_lets-see-how-es.mp3": "L3dO",
	"./audio/cavity-math_lets-see-how.mp3": "wbMb",
	"./audio/cavity-math_oh-no-es.mp3": "trrC",
	"./audio/cavity-math_oh-no.mp3": "YiEn",
	"./audio/cavity-math_remember-es.mp3": "ZX7m",
	"./audio/cavity-math_remember.mp3": "1+25",
	"./audio/cavity-math_thats-right-es.mp3": "hKgK",
	"./audio/cavity-math_thats-right.mp3": "SBy2",
	"./audio/do_you_want_to_play_again.mp3": "btUg",
	"./audio/drag_the_items_to_add_up_to_healthy_teeth.mp3": "/p5N",
	"./audio/good-for-me-or-good-for-cavity-monsters-es.mp3": "p4xF",
	"./audio/good-for-me-or-good-for-cavity-monsters.mp3": "NKZU",
	"./audio/good-job-es.mp3": "tdBG",
	"./audio/good-job.mp3": "3Cs/",
	"./audio/good_job_you_are_a_cavity_monster_hero.mp3": "Ztez",
	"./audio/good_job_you_are_fighting_the_cavity_monsters.mp3": "73oa",
	"./audio/putting_sugary_snacks_and_drinks_into_your_mouth.mp3": "02ft",
	"./audio/stop-the-cavity-monster_how-do-we-es.mp3": "3h2/",
	"./audio/stop-the-cavity-monster_how-do-we.mp3": "tl5U",
	"./audio/stop-the-cavity-monster_yeah.mp3": "FNp3",
	"./audio/stop-the-cavity-uh-oh-es.mp3": "dzwj",
	"./audio/stop-the-cavity-uh-oh.mp3": "UF9v",
	"./audio/stop-the-cavity_yeah-es.mp3": "Msec",
	"./audio/unlocked-new-badge-es.mp3": "203u",
	"./audio/unlocked-new-badge.mp3": "3hyA",
	"./avatar.png": "HfaK",
	"./baby-teeth.svg": "LAna",
	"./baby-teeth_disabled.svg": "QYp9",
	"./back-white.png": "ZnKJ",
	"./back.png": "P9/e",
	"./bacteria.svg": "heDi",
	"./beverage.svg": "mU1s",
	"./big_dots.png": "TSxL",
	"./block-users-icon.svg": "lDWh",
	"./book.svg": "DFmh",
	"./broccoli.svg": "s2L9",
	"./brush-timer-img.jpg": "SE3v",
	"./brush-twice-a-day.svg": "kXXK",
	"./brush-twice.svg": "p4rz",
	"./brush.svg": "7Hc3",
	"./brushing-after-meal.svg": "dde2",
	"./candy.svg": "sBCa",
	"./card.png": "mjAv",
	"./caries.svg": "3H5m",
	"./carrot.svg": "/FoG",
	"./cavity-math.svg": "oIpA",
	"./cavity-math_disabled.svg": "wXL3",
	"./cavity-monster-hero.svg": "iliP",
	"./cavity-prevention.svg": "qscY",
	"./characters/character-boy-1.png": "pi2C",
	"./characters/character-boy-2.png": "JkXn",
	"./characters/character-boy-3.png": "+hUp",
	"./characters/character-boy-4.png": "gJ0j",
	"./characters/character-girl-1.png": "brTx",
	"./characters/character-girl-2.png": "97bE",
	"./characters/character-girl-3.png": "OjvT",
	"./characters/character-girl-4.png": "DYqF",
	"./cheese.svg": "ydrz",
	"./chips.svg": "roWZ",
	"./chocolate.svg": "9dwY",
	"./clock.svg": "4lth",
	"./close-icon.svg": "1ItL",
	"./close-white.svg": "UFAX",
	"./close.svg": "f71c",
	"./confetti.png": "/Hre",
	"./congrats-img.svg": "k7wF",
	"./cookie.svg": "EaHi",
	"./course_detail.png": "oJGY",
	"./curses-img.jpg": "JfYh",
	"./dancing.svg": "QMaI",
	"./dental-floss.svg": "70tV",
	"./dentist.svg": "7zAW",
	"./donut-answer.svg": "nbpk",
	"./donut-question.svg": "j9Gl",
	"./donut.svg": "1hUQ",
	"./download_btn.png": "vKk5",
	"./edit-login-details-icon.svg": "DM4U",
	"./egg.svg": "3hUH",
	"./elephant.svg": "F1zE",
	"./eq-icon.png": "+heq",
	"./eq-icon.svg": "xuew",
	"./fav-courses-icon.svg": "vQLX",
	"./grapes.svg": "v3SA",
	"./gym.svg": "tsTS",
	"./heart.png": "YfaA",
	"./ice-cream.svg": "L27b",
	"./icon-en.svg": "hWQs",
	"./icon-es.svg": "B+bv",
	"./js/bodymovin": "UHoh",
	"./js/bodymovin.js": "UHoh",
	"./lessons.png": "UIoK",
	"./login.svg": "f9ik",
	"./logo.svg": "AqYs",
	"./main_bg.png": "uIF/",
	"./matching.svg": "X0Om",
	"./matching_disabled.svg": "tHf5",
	"./memory.svg": "C7Dp",
	"./memory_disabled.svg": "7MN0",
	"./milk.svg": "hwBL",
	"./monster.png": "H2Oy",
	"./mouth-sad": "tj+A",
	"./mouth-sad.json": "tj+A",
	"./mouth-smile": "OJDR",
	"./mouth-smile.json": "OJDR",
	"./mouth.svg": "sXM2",
	"./mouth_pop_correct.png": "SYKB",
	"./my-friends-icon.svg": "sPEQ",
	"./not-brushing.svg": "bWhL",
	"./orange-juice.svg": "FQwl",
	"./peanut.svg": "6GZ5",
	"./phone.png": "UqHI",
	"./phone.svg": "zwcc",
	"./play.png": "KBZJ",
	"./plus.svg": "1bhZ",
	"./popcorn.svg": "QrWV",
	"./prenatal.svg": "rtES",
	"./prenatal_disabled.svg": "uNT+",
	"./proper-brushing.svg": "epTf",
	"./proper-brushing_disabled.svg": "mJjl",
	"./raiting.png": "E04X",
	"./refresh.svg": "+Nkf",
	"./share-icon.svg": "mGnL",
	"./share.png": "az9f",
	"./sleep.svg": "d9Ce",
	"./soda-bottle.svg": "jH5c",
	"./soda.svg": "z932",
	"./star-icon.svg": "eIYB",
	"./step-dash.svg": "reF/",
	"./students.png": "nYe3",
	"./sugar.svg": "AaRY",
	"./sugar_disabled.svg": "HsUf",
	"./swipe_arrow.png": "sr7d",
	"./team-1.jpg": "fYtg",
	"./team-2.jpg": "Kvc2",
	"./team-3.jpg": "JhL1",
	"./team-4.jpg": "Vtcl",
	"./team-5.jpg": "O9eG",
	"./tooth.svg": "Dt7Q",
	"./toothpaste.svg": "HxS3",
	"./top-image.png": "QxNX",
	"./top.png": "Uw9C",
	"./uic-school-front.jpg": "bBHd",
	"./update-interests-icon.svg": "Stq+",
	"./user_icon.svg": "ph6f",
	"./user_review.svg": "FFNp",
	"./user_review_1.svg": "c6F6",
	"./video/lonely-astronaut-cover.jpg": "sTEH",
	"./video/lonely-astronaut.mp4": "O0vH",
	"./video/module1-cover.jpg": "ikv7",
	"./video/module1-female.mp4": "7KnL",
	"./video/module1-male.mp4": "bGXg",
	"./video/module1_spanish.mp4": "ndSI",
	"./video/module1b-female.mp4": "EhcX",
	"./video/module1b-male.mp4": "A4JE",
	"./video/module1b_spanish.mp4": "oOtz",
	"./video/module3-cover.jpg": "n3LL",
	"./video/module3-female.mp4": "2EIv",
	"./video/module3-male.mp4": "PG6q",
	"./video/module3_spanish.mp4": "iGbO",
	"./video/module4-cover.jpg": "LkeZ",
	"./video/module4-female.mp4": "JG5K",
	"./video/module4-male.mp4": "SA4Q",
	"./video/module4_spanish.mp4": "za5a",
	"./video/module5-cover.jpg": "re15",
	"./video/module5-female.mp4": "1BoC",
	"./video/module5-male.mp4": "M9yq",
	"./video/module5_spanish.mp4": "YlMr",
	"./video/module6-cover.jpg": "IVeL",
	"./video/module6-female.mp4": "UfNS",
	"./video/module6-male.mp4": "M18M",
	"./video/module6_spanish.mp4": "mEBl",
	"./wait.svg": "D0E1",
	"./water.svg": "1uaT",
	"./website.png": "qAou",
	"./website.svg": "TfzC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0